import 'angular:locale/data:fr-LU';
import './projects/munhowen/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
